import GoingUtils from "@/utils/goingUtils";
import i18n from "@/i18n";
import {isPxProp} from "@/main-page-base/utils/styleSetUtils";
import {unref} from "vue";

const {t} = i18n.global;

export function getPropUnit(propName, styles) {
  if (styles[propName + 'Unit']) {
    return styles[propName + 'Unit']
  }
  //如果是间距属性 则获取间距单位
  if (propName.indexOf("Margin") >= 0 || propName.indexOf("margin") >= 0) {
    return styles["marginUnit"] || GoingUtils.defUnit;
  }
  if (propName.indexOf("Padding") >= 0 || propName.indexOf("padding") >= 0) {
    return styles["paddingUnit"] || GoingUtils.defUnit;
  }
  return GoingUtils.defUnit;
}



//获取内间距样式信息
export const getPaddingStyJson = function (sty, styles) {
  for (const prop in styles) {
    if (prop.indexOf("padding") >= 0) {
      if (isPxProp(prop)) {
        if (parseFloat(styles[prop]) - styles[prop] === 0) {
          sty[prop] = styles[prop] + getPropUnit(prop, styles)||"px";
        } else {
          sty[prop] = styles[prop];
        }
      }
    }
  }
}
//获取外间距内容
export const getMarginStyJson = function (sty, styles) {
  for (const prop in unref(styles)) {
    if (prop.indexOf("margin") >= 0) {
      if (isPxProp(prop)) {
        if (parseFloat(styles[prop]) - styles[prop] === 0) {
          sty[prop] = styles[prop] + getPropUnit(prop, styles)||"px";
        } else {
          sty[prop] = styles[prop];
        }
      }
    }
  }
}

export function getWidth(sty, heightProp, lrPadding=0) {
  //高度设置
  if (heightProp) {
    if (heightProp - parseFloat(heightProp) === 0) {
      sty["width"] = parseFloat(heightProp) + parseFloat(lrPadding) + GoingUtils.defUnit;
    } else {
      sty["width"] = heightProp;
    }
  }
}

export function getHeight(sty, heightProp,gridDivFlag,heightChange=0) {
  //高度设置
  if (heightProp) {
    if (heightProp - parseFloat(heightProp) === 0) {
      sty["height"] = heightProp + GoingUtils.defUnit;
    } else {
      if(gridDivFlag){
        if(heightChange&&parseFloat(heightChange)>0){
          sty["height"] = `calc(calc(${heightProp} - ${heightChange}px) + ${'var(--gridPadding,0px)'})`;
        }else{
          sty["height"] = `calc(${heightProp} + ${'var(--gridPadding,0px)'})`;
        }
      }else{
        sty["height"] = heightProp;
        //如果高度chang包含% 才需要执行
        if(heightChange>0&&heightProp.indexOf("%")>0){
          sty["height"] = `calc(100% - ${heightChange||0}px)`;
        }
      }
    }
  }
}

/**
 * 获取背景图片信息
 * @param sty
 * @param styles
 */
export const getBackgroundImage=function (sty, styles){
  for (const prop in styles) {
    if (prop === 'shadowFlag' && styles[prop]) {
      sty["box-shadow"] = `${styles['hShadow']}px ${styles['vShadow']}px ${styles['blur']}px ${styles['spread']}px ${styles['shadowColor']}`;
    }
    if (prop === 'bgImage') {
      sty['background-image'] = `url('${styles[prop]}')`;
      if(!isNaN(parseFloat(styles["xpos"]))){
        sty['background-position'] = `${parseFloat(styles["xpos"])}px ${parseFloat(styles["ypos"])}px`;
      }else{
        sty['background-position'] = `${styles["xpos"]} ${styles["ypos"]}`;
      }
    }
    if (prop === 'backgroundRepeat') {
      sty['background-repeat'] = `${styles["backgroundRepeat"]}`;
    }
    if (prop === 'backgroundSize') {
      sty['background-size'] = `${styles["backgroundSize"]}`;
    }
    //颜色渐变标志
    if (prop === 'linearFlag') {
      if (unref(styles).linearFlag !== false) {
        sty["background"] = `linear-gradient(303deg,${styles['startBgColor']} 10%,${styles['endBgColor']} 80%)`;
      }
    }
  }
}
/**
 * 获取style的信息
 * @param sty
 * @param styles
 */
export const getStyJson = function (sty, styles, props, lrPadding = 0) {
  getBackgroundImage(sty,styles);
  for (const prop in styles) {
    if (prop === 'align') {
      sty["text-align"] = `${styles[prop]}`;
    }
    if (isPxProp(prop)) {
      if (parseFloat(styles[prop]) - styles[prop] === 0) {
        sty[prop] = styles[prop] + getPropUnit(prop, styles)||"px";
      } else {
        sty[prop] = styles[prop];
      }
    } else {
      if ((prop + "").indexOf("Unit") > 0 || (prop + "").indexOf("startBgColor") >= 0 || (prop + "").indexOf("endBgColor") >= 0) {
        console.log(prop, "====")
      } else {
        if (prop === 'fontColor') {
          sty["color"] = styles[prop];
        } else {
          sty[prop] = styles[prop];
        }
      }
    }
  }
  setBorderRadiusStyl(sty, styles);
  if (unref(props)) {
    //获取高度
    getHeight(sty, unref(props)["height"],unref(props).gridDivFlag,unref(props).heightChange);
    //获取宽度
    getWidth(sty, unref(props)["width"], lrPadding);
  }
}


export const setBorderRadiusStyl = function (sty, styles) {
  delete sty["borderColor"];
  delete sty["borderStyle"];
  delete sty["topBorderWidth"];
  delete sty["rightBorderWidth"];
  delete sty["leftBorderWidth"];
  delete sty["bottomBorderWidth"];
  styles = unref(styles);
  //批量设置边框信息
  if (styles && styles["borderSetType"] === 'borderSet') {
    sty["border-radius"] = sty["borderRadius"] + GoingUtils.defUnit;
  }
  //单个设置边框信息
  if (styles && styles["borderSetType"] === 'borderSingleSet') {
    sty["border-top-left-radius"] = sty["leftTopBorderRadius"] + GoingUtils.defUnit;
    sty["border-top-right-radius"] = sty["rightTopBorderRadius"] + GoingUtils.defUnit;
    sty["border-bottom-right-radius"] = sty["rightBottomBorderRadius"] + GoingUtils.defUnit;
    sty["border-bottom-left-radius"] = sty["leftBottomBorderRadius"] + GoingUtils.defUnit;
  }
  if (styles && styles["bottomBorderWidth"] > 0) {
    sty["border-bottom"] = `${styles["bottomBorderWidth"]}px ${styles["borderStyle"]} ${styles["borderColor"]}`;
  }
  if (styles && styles["topBorderWidth"] > 0) {
    sty["border-top"] = `${styles["topBorderWidth"]}px ${styles["borderStyle"]} ${styles["borderColor"]}`;
  }
  if (styles && styles["rightBorderWidth"] > 0) {
    sty["border-right"] = `${styles["rightBorderWidth"]}px ${styles["borderStyle"]} ${styles["borderColor"]}`;
  }
  if (styles && styles["leftBorderWidth"] > 0) {
    sty["border-left"] = `${styles["leftBorderWidth"]}px ${styles["borderStyle"]} ${styles["borderColor"]}`;
  }
}
